import * as debug from "../utils/debug";

const API_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? `${window.location.protocol}//${window.location.hostname}:8000`
    : process.env.REACT_APP_API_BASE_URL;


// Zentrale für:
// * credentials
// * JSON headers
// * error handling
// * logging
// * response validation
async function request(path, options = {}) {
  try {
    debug.log(`api-request: ${path} [${options.method ?? 'GET'}] ${JSON.stringify(options?.body ?? '')}`)
  
    const res = await fetch(`${API_BASE_URL}${path}`, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {})
      },
      ...options
    });
  
    if (!res.ok) {
      debug.log(`api-error: ${path} ${JSON.stringify(res)}`)
      throw new Error(`API Error ${res.status}`);
    }

    let data = await res.json();

    debug.log(`api-response: ${path} ${JSON.stringify(data)}`)
    return data

  } catch (err) {
    console.error("API request failed:", err);

    throw err;
  }
}

export const api = {

  health: () =>
    request("/health"),

  getQuizzes: () =>
    request("/quizzes"),

  unlockQuiz: (payload) =>
    request("/unlock-quiz", {
      method: "POST",
      body: JSON.stringify(payload)
    }),

  loadQuestion: (payload) =>
    request("/question", {
      method: "POST",
      body: JSON.stringify(payload)
    }),

  answer: (payload) =>
    request("/answer", {
      method: "POST",
      body: JSON.stringify(payload)
    }),

  stop: (payload) =>
    request("/stop", {
      method: "POST",
      body: JSON.stringify(payload)
    }),

  restart: (payload) =>
    request("/restart", {
      method: "POST",
      body: JSON.stringify(payload)
    }),

  exportResult: () =>
    request("/export")    
};

export default api;
